import React from 'react';
import {BeneficiaryInfo} from 'commons/types/Types';

export type EfeBeneficiaryContextType = {
    percentageCompleted: number;
    setPercentageCompleted: (value: number) => void;
    beneficiaries: BeneficiaryInfo[];
    setBeneficiaries: (data: BeneficiaryInfo[]) => void;
    tempBeneficiary: BeneficiaryInfo | undefined;
    setTempBeneficiary: (data: BeneficiaryInfo | undefined) => void;
    isActive: boolean;
    authorization: boolean;
    setAuthorization: (data: boolean) => void;
    setActive: (data: boolean) => void;
    resetBeneficiaryContext: () => void;
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const OnboardingBeneficiaryContext = React.createContext<EfeBeneficiaryContextType>();

export function useBeneficiaryContext() {
    return React.useContext(OnboardingBeneficiaryContext);
}

export default OnboardingBeneficiaryContext;
